module.exports = "<div class=\"tile control\" #tile>\n<div class=\"control photo\" #photo>\n</div>\n<div>"


//////////////////
// WEBPACK FOOTER
// /home/artur/workspace/vscode/warpriders/src/app/content/libs/image-zoom/image-zoom.component.html
// module id = ../../../../../src/app/content/libs/image-zoom/image-zoom.component.html
// module chunks = 1